import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import styles from "../styles";
import headerApp from "../../assets/jss-component/HeaderApp";
import classNames from "classnames";
import Modules from "../../common/Modules";
import { Route } from "react-router-dom";

class Wrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { classes, anchor, open } = this.props;

    return (
      <main
        className={classNames(classes.content, classes[`content-${anchor}`], {
          [classes.contentShift]: open,
          [classes[`contentShift-${anchor}`]]: open
        })}
      >
        <div className={classes.appBarSpacer}>
          <Route path="/cost" component={Modules.Cost} />
          <Route path="/mac" component={Modules.Mac} />       
          <Route path="/lima" component={Modules.Lima} />
          <Route path="/medi" component={Modules.Medi} />
          <Route path="/bas" component={Modules.Bas} />
          <Route path="/mob" component={Modules.Mob} />
          <Route path="/spac" component={Modules.Spac} />
          <Route path="/adm" component={Modules.Adm} />
          <Route path="/cambiar-hora" component={Modules.CambiarHora} />
        </div>
      </main>
    );
  }
}

export default withStyles(styles, { withTheme: true }, headerApp)(Wrapper);
